var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{staticClass:"picture",attrs:{"data-anim":_vm.isLazy ? 'picture' : _vm.isLazy}},[_c('img',{staticClass:"picture__img",attrs:{"src":!_vm.isLazy ? _vm.data.src : !_vm.isLazy,"data-src":_vm.isLazy ? _vm.data.src : _vm.isLazy,"alt":_vm.data.alt}}),_c('div',{staticClass:"picture__div-img",style:({
      backgroundImage: _vm.isLazy ? !_vm.isLazy : ("url(" + (_vm.data.src) + ")"),
    })})])}
var staticRenderFns = []

export { render, staticRenderFns }